/** ドラッグ中のタブが、エディタペイン内のどの領域にかかっているか。edge の4方向は分割、center はグループへの移動 (分割なし)。 */
export type EditorDropZone = "left" | "right" | "top" | "bottom" | "center";

/**
 * ペイン内の座標 (x, y はペイン左上からのオフセット) から、該当するドロップゾーンを判定する。
 * headerHeight 未満 (タブ列の帯) は常に center。それ以外はコンテンツ領域の各端から
 * edgeRatio 以内なら該当する辺、それ以外は center とする。
 */
export function resolveEditorDropZone(
	x: number,
	y: number,
	width: number,
	height: number,
	headerHeight: number,
	edgeRatio = 0.3,
): EditorDropZone {
	if (y < headerHeight) return "center";

	const contentHeight = height - headerHeight;
	const contentY = y - headerHeight;
	const leftDist = x / width;
	const rightDist = (width - x) / width;
	const topDist = contentHeight > 0 ? contentY / contentHeight : 1;
	const bottomDist = contentHeight > 0 ? (contentHeight - contentY) / contentHeight : 1;

	const min = Math.min(leftDist, rightDist, topDist, bottomDist);
	if (min >= edgeRatio) return "center";
	if (min === leftDist) return "left";
	if (min === rightDist) return "right";
	if (min === topDist) return "top";
	return "bottom";
}
